module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-view facturen",
    attrs: {
      "id": "pagingtop"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [(!_vm.pageDataLoaded) ? _c('loader-component') : _vm._e(), _vm._v(" "), (_vm.pageDataLoaded) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.chunkedArray[_vm.currentPage]), function(factuur) {
    return _c('tbody', {
      key: factuur.factuurnummer
    }, [_c('tr', {
      staticClass: "main",
      class: [{
        danger: factuur.openstaand === true
      }, {
        open: factuur.isOpen
      }],
      on: {
        "click": function($event) {
          factuur.isOpen = !factuur.isOpen
        }
      }
    }, [(factuur.openstaand) ? _c('td', {
      staticClass: "status unpaid",
      attrs: {
        "scope": "row"
      }
    }, [_c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (factuur.openstaand == false) ? _c('td', {
      staticClass: "status paid",
      attrs: {
        "scope": "row"
      }
    }, [_c('span', [_vm._v("v")])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(factuur.datum))]), _vm._v(" "), _c('td', {
      staticClass: "factuurnummer"
    }, [_vm._v(_vm._s(factuur.factuurnummer))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(factuur.produkt))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("€ " + _vm._s(factuur.bedrag))])]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('tr', {
      staticClass: "details"
    }, [_c('td', {
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "col-xs-12 col-mo-6 col-lg-3"
    }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('p', [(factuur.openstaand) ? _c('span', [_c('span', [_vm._v("Openstaand")])]) : _vm._e(), _vm._v(" "), (factuur.openstaand == false) ? _c('span', [_c('span', [_vm._v("Betaald")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-mo-6 col-lg-3"
    }, [_c('label', [_vm._v("Betaalwijze")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(factuur.betaalwijze))])]), _vm._v(" "), _c('div', {
      staticClass: "factuurnummer col-xs-12 col-mo-6"
    }, [_c('label', [_vm._v("Factuurnr")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(factuur.factuurnummer))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-mo-6 col-lg-3"
    }, [_c('label', [_vm._v("Periode")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(factuur.periode))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-mo-6 col-lg-3"
    }, [_c('label'), _c('p', [_c('span', {
      staticClass: "icon clean"
    }, [_vm._v("p")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.ctx + '/' + factuur.pdflink,
        "target": "_blank"
      }
    }, [_vm._v("Download factuur")])])])])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "error"
    }
  }), _vm._v(" "), (_vm.totalPages > 1) ? _c('nav', {
    staticClass: "paging"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item"
  }, [(_vm.currentPage > 0) ? _c('button', {
    staticClass: "previous btn btn-secondary",
    attrs: {
      "data-href": "#pagingtop",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentPage -= 1
      }
    }
  }, [_vm._v("Vorige")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.totalPages), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      staticClass: "page-item"
    }, [_c('button', {
      staticClass: "btn btn-secondary",
      class: {
        active: pageNumber === _vm.currentPage + 1
      },
      attrs: {
        "data-href": "#pagingtop",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.currentPage = pageNumber - 1
        }
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [(_vm.currentPage < _vm.totalPages - 1) ? _c('button', {
    staticClass: "next btn btn-secondary",
    attrs: {
      "data-href": "#pagingtop",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentPage += 1
      }
    }
  }, [_vm._v("Volgende")]) : _vm._e()])], 2)]) : _vm._e(), _vm._v(" "), (_vm.pageDataLoaded) ? _c('p', {
    staticClass: "aantalfacturen"
  }, [(_vm.totaalFacturen === 1) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.totaalFacturen))]), _vm._v(" factuur gevonden")]) : _c('span', [_c('strong', [_vm._v(_vm._s(_vm.totaalFacturen))]), _vm._v(" facturen gevonden")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Factuurdatum")]), _vm._v(" "), _c('th', {
    staticClass: "factuurdatum"
  }, [_vm._v("Factuurnr.")]), _vm._v(" "), _c('th', [_vm._v("Verzekering")]), _vm._v(" "), _c('th', [_vm._v("Bedrag")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "icon clean"
  }, [_vm._v("+")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-920c241c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/facturen.vue
// module id = 103
// module chunks = 0